import { FC } from "react"

import AnalyticsTitle from "@/pages/Analytics/Common/AnalyticsTitle"

const AnalyticsOffersPage:FC = ()=>{
    return (
        <div>
            <AnalyticsTitle 
                text={"Динамика предложений"}
            />
        </div>
    )
}

export default AnalyticsOffersPage